import {
    SAVE_DATA_FROM_MAIN_PAGE_FORM
} from "../actions";


// for testing
// let initialState = {
//     insurees_data: {
//         insuree_object: {
//             nationality: "Ukraine",
//             age: '28'
//         },
//         dependents_array: [
//             {
//                 nationality: "France",
//                 age: '16'
//             }
//         ],
//         destination_country: "États-Unis d’Amérique",
//         insurance_duration: '12+',
//         insuree_has_cfe: 'NO'
//     }
// };

let initialState = {
    insurees_data: null
};




export function main_form_reducer(state = initialState, action) {
    switch (action.type) {
        case SAVE_DATA_FROM_MAIN_PAGE_FORM :

            return {
                ...state,
                insurees_data: action.payload
            };

        default:

            return state
    }
}
